export default function suggestPopLanguage() {
    function suggestPopLanguage() {
        $('.close-pop-btn').click(function () {
            $(this).closest('.suggest-lang-pop').hide();
            setVisitedLang();
        });

        $('.gl-language-item').click(function () {
            let lang = $(this).attr('href');
            setCookie('visitLanguage', lang, 30);
            setVisitedLang();
        });

        if (sessionStorage.getItem('redirectedToLang') == "true") {
            $('.suggest-lang-pop').hide();
        } else {
            $('.suggest-lang-pop').show();
        }
    }

    function lastVisitLanguage() {
        let currentUrl = document.location.pathname;
        let isFrontpage = (/(en|cn|fr|es|de|da)\/front-page/g).test(currentUrl);
        let isRedirectedLang = sessionStorage.getItem('redirectedToLang');
        if (isRedirectedLang != 'true' && isFrontpage) {

            let lang = getCookie('visitLanguage');

            if (lang != '' && lang != undefined) {
                setVisitedLang();
                document.location.replace(lang);
            }
        }
    }

    function setVisitedLang() {
        sessionStorage.setItem('redirectedToLang', 'true');
    }

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    if ($('.suggest-lang-pop').length > 0) {
        lastVisitLanguage();
        suggestPopLanguage();
    }
}